import { useState } from "react";
import { useSelector } from "react-redux";
import { Modal, Select } from "risa-oasis-ui_v2";
import { CptCodesTableRowModel } from "../../../data-model/cptCodesTableModel";
import { ModalId } from "../../../enums/modalId";
import { RootState } from "../../../redux/store/store";
import { createDataForCommentsAndPushToLocalStorage } from "./utils/createDataForCommentsAndPushToLocalStorage";

interface StatusUpdateModalProps {
  onClose: () => void;
  rowData?: CptCodesTableRowModel;
}

export interface AuthStatusChange {
  identifier: string;
  j_code: string;
  old_value: string;
  new_value: string;
  updated_at: string;
  reason: string;
  comment: string;
  updated_by: string;
}

export const StatusUpdateModal = (props: StatusUpdateModalProps) => {
  const [reason, setReason] = useState<string | null>(null);
  const [textareaContent, setTextareaContent] = useState<string>("");
  const { metaData } = useSelector((state: RootState) => state.modal);
  const { singleMedicalPaOrder } = useSelector(
    (state: RootState) => state.singleMedicalPaOrder,
  );
  const { user } = useSelector(
    (state: RootState) => state.firebaseAuthentication,
  );

  const handleClose = () => {
    props.onClose();
  };

  const handleSave = () => {
    if (
      !singleMedicalPaOrder?.id ||
      !reason ||
      !metaData?.commentType ||
      !user?.id
    ) {
      return;
    }
    createDataForCommentsAndPushToLocalStorage(
      singleMedicalPaOrder?.id ?? "",
      textareaContent.trim(),
      reason ?? "",
      props?.rowData?.jCodes?.data ?? "",
      (metaData?.commentType as "denial" | "query" | "query_resolution") ?? "",
      user?.id ?? "",
    );
    props.onClose();
  };

  const isFormValid = reason && textareaContent.trim().length > 0;

  return (
    <Modal
      dialogId={ModalId.STATUS_UPDATE_MODAL}
      title="Status Update"
      onClose={handleClose}
      onSave={handleSave}
      saveButtonText="Save"
      cancelText="Cancel"
      disableSave={!isFormValid}
      hideFooter={false}
    >
      <div className="flex flex-col gap-3">
        <Select
          id="status-update"
          label={metaData?.label || "Reason for Query"}
          options={metaData?.options || []}
          onOptionChange={(option) => {
            setReason(option.value);
          }}
          placeholder={metaData?.placeholder || "Select the Reason for Query"}
          value={reason ?? undefined}
        />
        <div className="mb-2 flex flex-col gap-2">
          <div className="text-tiny font-normal text-primaryGray-2">
            Comments
          </div>
          <textarea
            placeholder="Enter additional details..."
            value={textareaContent}
            onChange={(e) => setTextareaContent(e.target.value)}
            className="h-20 w-full resize-none rounded-md border border-primaryGray-14 p-3 text-small placeholder-gray-400 focus:outline-none"
          />
        </div>
      </div>
    </Modal>
  );
};
